import React, { Component } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { Container, Row, Col, Form, Button, Image, Modal } from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import ReCAPTCHA from "react-google-recaptcha";
import NavbarComponent from '../Navbar';
import LogoWirebit from '../../Images/Logos/LogoAzul.png';
import { Bounce } from 'react-activity';
import Connection from '../../Calls';
import Backend from '../../Backend';
import es from '../../translate/es';
import en from '../../translate/en';
import ModalForgot from '../Forgot';
import Modaltwofa from '../2fa';

import './index.css';

class NewLogin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reCaptcha: '',
      email: '',
      password: '',
      group_nick:'',
      showLoad: false,
      show2FA:false,
      showModalLogin: false,
      showModalForgot:false,
      code:'-',
      text:en
    }
    this.handleShowLogin = this.handleShowLogin.bind(this);
    this.handleCloseLogin = this.handleCloseLogin.bind(this);
    this.handleReturnLogin = this.handleReturnLogin.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleCloseForgot = this.handleCloseForgot.bind(this);
    this.handleShowForgot = this.handleShowForgot.bind(this);
    this.TwoFAConfirm = this.TwoFAConfirm.bind(this);
  }

  componentWillMount() {
    this.bQk7VZx7();
    if(this.props.lan === 'es') {
      this.setState({text: es})
    } else {
      this.setState({text: en})
    }
    // this.listenerStorage()
  }

  // listenerStorage(){
    // const self =this;
    // var originalSetItem = localStorage.setItem;
    // localStorage.setItem = function(){
    //   document.createEvent('Event').initEvent('itemInserted', true, true);
    //   originalSetItem.apply(this, arguments);
    //   if(localStorage.getItem('lan') === 'es') self.setState({text:es})
    //   else self.setState({text:en})
    // }
  //   if(this.props.lan === 'es') this.setState({text:es})
  //     else this.setState({text:en})
  // }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {

      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  loginFunc() {

    const self = this;
    var limoncitos = Connection.Uwx6GVhZ();
    self.setState({ showLoad: true });
    if(this.state.code != '-'){
      var code = this.state.code
    }else{
      var code = ':)'
    }

    if (this.state.email !== "" && this.state.password !== "") {
      if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email) !== false) {
        if (this.state.reCaptcha !== "") {
          let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
          navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
          });
          result = latitude + longitude;
          Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            var responseEZcga8qH = response.payload.r01;
            var authorization = Connection.RThzHrsb("XPUR703")
            var key = Connection.RThzHrsb(this.state.password)
            // var w03 = Backend.GenerateHash(this.state.email, passwordRandom, this.state.reCaptcha, response.payload.r01, this.state.password);
            // console.log(confirmation, date, result, "Dzj91zk", authorization, "XPUR703", this.state.email, passwordRandom, this.state.reCaptcha, responseEZcga8qH, key);
            Connection.Pd4axZxJ(confirmation, date, result, "Dzj91zk", authorization, "XPUR703", this.state.email, limoncitos, this.state.reCaptcha, responseEZcga8qH, key, response => {
              Backend.Login(this.state.email, response.payload.r03, limoncitos, this.state.reCaptcha, responseEZcga8qH, code, async response => {
                if (response.status.code === "0") {
                  if(response.payload['token'] === "2FA"){
                    this.setState({show2FA:true, showLoad: false})
                  }else{
                    var token = response.payload.token;

                    store.addNotification({
                      title: "Success!",
                      message: response.payload.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 3000,
                        onScreen: true
                      }
                    });
                    localStorage.setItem('token', token);
                    localStorage.setItem('email', self.state.email);
                    localStorage.setItem('alias', response.payload.group_nick);


                    Backend.general_get('get_wallets_settings',responseEZcga8qH,response=>{
                      if(response.status.code == "18004") localStorage.setItem('ecomm','false')
                      else localStorage.setItem('ecomm','true')
                    })

                    if (response.payload.vexchange === 'enabled') localStorage.setItem('vexchange', 'enabled');

                    let sendToKyc = false
                    let typeRequested = ''

                    await Backend.get_client_data(self.state.email, token, responseEZcga8qH, response => {
                      if (response.payload.client_info.pending_upgrade === 'rejected') {
                        sendToKyc = true
                        typeRequested = response.payload.client_info.type_requested
                      }
                    })

                    setTimeout(function () {
                      if (sendToKyc) {
                        self.props.data.history.push({
                          pathname: "/Kyc",
                          state: { type_requested: typeRequested}
                        })
                      } else {
                        self.props.data.history.push("/wallets")
                      }
                      self.setState({ email: '', password: '', reCaptcha: '', showLoad: false });
                     }, 2000);
                  }

                } else {
                  if(response.status.code == "2016") this.setState({code:'-', show2FA:true})
                  store.addNotification({
                    title: "Error!",
                    message: response.status.description,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 3000,
                      onScreen: true
                    }
                  });
                  self.setState({ showLoad: false });
                }
              });
            });
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: this.state.text.Login.errorCaptcha,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true
            }
          });
          self.setState({ showLoad: false });
        }
      } else {
        store.addNotification({
          title: "Error!",
          message: this.state.text.Login.errorEmail,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        self.setState({ showLoad: false });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: this.state.text.Login.errorEmpty,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      self.setState({ showLoad: false });
    }
  }

  TwoFAConfirm(code){
    if(code =='cancel') this.setState({code:'-',show2FA:false})
    else this.setState({code,show2FA:false},()=>this.loginFunc())

  }

  redirectLanding() {
    this.props.data.history.push("/");
  }

  /* Funciones para los modales */
  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  handleShowLogin() {
    this.setState({ showModalLogin: true });
  }
  handleCloseLogin() {
    this.setState({ showModalLogin: false });
  }
  handleCloseForgot() {
    this.setState({ showModalForgot: false });
  }
  handleShowForgot() {
    this.setState({ showModalForgot: true });
  }
  handleForgotPassword() {
    const self = this;
    self.setState({ showModalLogin: false });
    setTimeout(function () {
      self.setState({ showModalForgot: true });
    }, 500);
  }
  handleReturnLogin() {
    const self = this;
    self.setState({ showModalForgot: false });
    setTimeout(function () {
      self.setState({ showModalLogin: true });
    }, 500);
  }
  /* Funciones para los modales */

  render() {
    return (
      <div className="newLoginBG ">
        {/* <NavbarComponent data={this.props} selected="login" /> */}
          <div className="container-signup">
            <Container>
              <div className='d-flex flex-column align-items-center' style={{marginBottom: '20px', cursor: 'pointer'}} onClick={() => { this.redirectLanding() }}>
                <Image src="/wirebit-new.webp" style={{ width: 50, marginBottom: '6px' }} />
                <Image src="/wirebit-logo-new.webp" style={{ width: 100 }} />
              </div>
              <div className="border-title-separator-container">
                <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                  <div className='d-flex justify-content-center'>
                    <span className='title-login'>{this.state.text.Login.welcome}</span>
                  </div>
                  <p className="subtitle-login" style={{textAlign:'center', color: '#4565ff'}}>{this.state.text.Login.title}</p>
                </div>
              </div>
              <div className="align-text">
                <span className="regular-text">{this.state.text.Login.SignIn}</span>
                <a className="link-account" onClick={() => this.props.data.history.push("/register")}>{this.state.text.Login.createAccount}</a>
              </div>
              <div>
                <Form.Group>
                  <Form.Label column sm="2" className="label-font">{this.state.text.Login.L_mail}</Form.Label>
                  <center>
                    <Col sm="10">
                      <Form.Control
                        type="email"
                        // placeholder={this.state.text.Login.P_mail}
                        className="input-login"
                        value={this.state.email}
                        onChange={(email) => { this.setState({ email: email.target.value }) }}
                      />
                    </Col>
                  </center>
                </Form.Group>
                <Form.Group style={{marginBottom: '5%'}}>
                  <Form.Label column sm="2" className="label-font">{this.state.text.Login.L_Password}</Form.Label>
                  <center>
                    <Col sm="10">
                      <Form.Control
                        type="password"
                        // placeholder="********"
                        className="input-login"
                        value={this.state.password}
                        onChange={(password) => { this.setState({ password: password.target.value }) }}
                      />
                    </Col>
                  </center>
                </Form.Group>
              <div>
                <center style={{ marginBottom: 0 }}>
                  {
                    (this.state.vertice) &&
                    <ReCAPTCHA
                      theme="light"
                      sitekey={this.state.vertice}
                      onChange={this.handleChange.bind(this)}
                    />
                  }
                </center>
              </div>
              <div>
                <div style={{ marginTop: 30, textAlign: "center" }}>
                  <Button className="btn-submit" variant="primary" onClick={() => { this.loginFunc() }} disabled={this.state.showLoad}>
                    {
                      this.state.showLoad ?
                        <Bounce size={20} color={"#FFFFFF"} animating={this.state.showLoad} />
                          :
                        <p className="label-btn-login">{this.state.text.Login.title}</p>
                    }
                  </Button>
                </div>
                <div style={{ marginTop: 25, marginBottom:25, textAlign: "center" }}>
                  <Button className="label-forgot-pwd" variant="link" onClick={() => { this.handleForgotPassword() }}>{this.state.text.Login.link_Forgot}</Button>
                </div>
              </div>
            </div>
            </Container>
          </div>
        <Modaltwofa modal showModalTwofa={this.state.show2FA} TowFAConfirm={this.TwoFAConfirm} traductions={this.state.text}/>
        <ModalForgot handleReturnLogin={this.handleReturnLogin} handleCloseForgot={this.handleCloseForgot} handleShowForgot={this.handleShowForgot} showModalForgot={this.state.showModalForgot} data={this.props} />
      </div>
    );
  }
} export default NewLogin;
